import {useProject, useProjectId, useProjectUnitSystem} from "../../shopdrawing/ProjectName";
import {AnchorElevationLink} from "./AnchorElevationLink";
import {DrwKind, isDrwDefault} from "../../shopdrawing/openings/drwDefaultElevation";
import {DrwDoorThermalCheckbox} from "../../shopdrawing/openings/DrwDoorThermalCheckbox";
import React, {useContext, useState} from "react";
import {useUser} from "../../../../misc/Permission";
import {useTabQueryParam} from "../../../../misc/userpref/useTabQueryParam";
import {QuoteOpening} from "../../../../api/QuoteOpenings";
import {
    actionsColName,
    AdjustCol, Column,
    DistanceCol, imperialInchParser, keyMatch, lookupNestedProp, makeSelectWrapper, NestedKeyOf, NominalWidth,
    NumberCol,
    Select2Col, SelectCol, SelectInput, SeqNumber, sortString, sortStringInner,
    StringCol,
    Table, TID
} from "../../../../misc/scroller/Table";
import {QuoteContainer} from "../QuoteContainer";
import {AutoInsertOpening} from "../../shopdrawing/openings/AutoInsertOpening";
import {api} from "../../../../api/API";
import {adoptHardwareElevation} from "../../shopdrawing/openings/adoptHardwareElevation";
import {useConfirm} from "../../../../misc/Confirm";
import {EditHardwareGroup} from "../../shopdrawing/openings/EditHardwareGroup";
import {RowActions} from "./RowActions";
import {ImperialDistance} from "../../../../misc/ImperialDistance";
import {MetricDistance} from "../../../../misc/MetricDistance";
import {CircularProgress, Grid, Tab, Tabs, Tooltip} from "@mui/material";
import {useNavigate} from "react-router-dom";
import {hardwareElevationToolUrl, openElevation} from "../../shopdrawing/openings/elevationToolLink";
import {ChangeCircleOutlined, OpenInNew, NoteAddOutlined} from "@mui/icons-material";
import {PickScreenElevation} from "./PickScreenElevation";
import {clearScreenSlot, parseScreenSlotPayload, screenSlotLabel, screenSlotPayload} from "../../shopdrawing/openings/screenSlot";
import {PickDoorElevation} from "./PickDoorElevation";
import {PickHardwareElevation} from "./PickHardwareElevation";
import {ElevationSidebar} from "../../shopdrawing/openings/elevationSidebar/ElevationSidebar";
import {ElevationCellFocusReporter, elevationColumnNames, ElevationSidebarProvider, UnlessElevationSidebarOpen} from "../../shopdrawing/openings/elevationSidebar/ElevationSidebarContext";
import {ReviewDrwElevations} from "./ReviewDrwElevations";
import {TabWrapper} from "../../shopdrawing/TabWrapper";
import {OpeningSwitcher} from "../../shopdrawing/openings/OpeningSwitcher";
import {first} from "nate-react-api-helpers";
import {useAlternative} from "../alternative/Alternative";
import {PrepLocations} from "./PrepLocations";
import {Opening} from "../../../../api/Openings";
import {ProductCol} from "../../shopdrawing/div10/Div10Table";
import {PrepDetail} from "../../../../api/QuoteHardware";
import {TextEditCell} from "./TextEditCell";
import {ScreenElevationPopup} from "./ScreenElevationPopup";
import {NewRowMenu} from "./NewRowMenu";
import {BreakHardwareLinkContext, BreakHardwareLinkProvider} from "./BreakHardwareLinkProvider";
import {ConfirmAdoptIdentityProvider, useConfirmAdoptIdentity} from "../../shopdrawing/openings/ConfirmAdoptIdentityProvider";
import {MakeQuoteSubmittal} from "../../shopdrawing/openings/MakeSubmittal";
import {QuoteSubmittalHistory} from "./QuoteSubmittalHistory";
import StorefrontIcon from "@mui/icons-material/Storefront";
import {HeaderActionButton} from "../../shopdrawing/HeaderActionButton";
import {ManageProjectSuppliers} from "../../shopdrawing/hardware/ManageProjectSuppliers";
import {SupplierProvider} from "../../shopdrawing/hardware/SupplierContext";
import {AnchorQty} from "./AnchorQty";
import {UnitSystem} from "../../../../api/Projects";
import {projectTablePrefName} from "../../shopdrawing/TablePrefName";
import {SubmittalsMenu} from "../../shopdrawing/openings/SubmittalsMenu";
import {DrawingWallLabelPopup} from "./DrawingWallLabelPopup";
import {ReviewWallTypes, ReviewWallTypeTitle} from "./ReviewWallTypes";
import {ReviewScreenElevations, ReviewScreenElevationTitle} from "./ReviewScreenElevations";
import {Checkbox2Col} from "../../shopdrawing/ShopTableCol";
import {
    applyDoorSeriesByOthers,
    applyFrameSeriesByOthers,
    copyDoorSeries,
    copyFrameSeries,
    DoorByOthersCell,
    DoorSeriesHeader,
    FrameByOthersCell,
    FrameSeriesHeader,
    pasteDoorSeries,
    pasteFrameSeries
} from "../../shopdrawing/openings/ByOthers";
import {PhaseCol} from "../../shopdrawing/openings/PhaseCol";
import {getAll} from "../../../logistics/routes/useGetAll";
import {DoorElevationSelector} from "./DoorElevationSelector";
import {
    ProjectProperties,
    ProjectPropertiesContext,
    ProjectPropertiesProvider
} from "../../shopdrawing/ProjectProperties";
import {ReviewDoorElevations, ReviewDoorElevationTitle} from "./ReviewDoorElevations";
import {CheckboxProvider} from "../../shopdrawing/Checkbox";
import {OpeningBulkActions} from "./OpeningBulkActions";
import {ProjectPageTitle} from "../../shopdrawing/ProjectPageTitle";
import {grey} from "@mui/material/colors";
import {
    aluminumFrame, doorSeries,
    existingFrame, frameSeries, hollowMetalDoor,
    hollowMetalFrame,
    kdFrameConstruction, labels,
    weldFrameConstruction
} from "./Const";
import {
    DoorElevationCell,
    DoorElevationColumnHeader,
    DoorElevationFilter, renderDoorElevationStr
} from "../../shopdrawing/openings/DoorElevationHelpers";
import { ScreenElevationHeader } from "./ScreenElevationHeader";
import { WallTypeHeader } from "./WallTypeHeader";
import {ext} from "../../../../api/Files";
import {ReviewFrameProfiles, ReviewTitle} from "./ReviewFrameProfiles";
import {ReviewAnchors} from "./ReviewAnchors";
import {ddlDoorSeriesFilter, DropDownContext, useDropdownData} from "../../settings/DropDowns";
import {WoodDetails} from "../../shopdrawing/openings/WoodDetails";
import {ReviewDoorCore} from "./ReviewDoorCore";
import {ReviewDoorSeam} from "./ReviewDoorSeam";
import {useShortCodeSearch} from "./ShortCodeSearch";

export function quoteOpeningsTableName(project: number, tab = "all") {
    return projectTablePrefName("project.quoteOpenings." + tab, project)
}

// --- drw elevation copy/paste + clear (quote mirror of shopdrawing/openings/Openings.tsx) ---
// Linking/unlinking a quote opening's drw elevation is a server operation, not a field on the
// upsert: door assigns a shared FK, screen also adopts identity, hardware clones the source. So
// copy encodes the source elevation id and backspace signals a clear; paste/clear stash an intent
// on the row, and onChange/onBulkChange dispatches the matching adopt/unlink endpoint.
type DrwAdoptKind = "door" | "screen" | "hardware";

function drwAdoptField(kind: DrwAdoptKind): string {
    return kind === "door" ? "__adoptDoorElevation"
        : kind === "screen" ? "__adoptScreenElevation"
        : "__adoptHardwareElevation";
}

function drwUnlinkField(kind: DrwAdoptKind): string {
    return kind === "door" ? "__unlinkDoorElevation"
        : kind === "screen" ? "__unlinkScreenElevation"
        : "__unlinkHardwareElevation";
}

function drwElevationField(kind: DrwAdoptKind): keyof QuoteOpening {
    return kind === "door" ? "drwDoorElevation"
        : kind === "screen" ? "drwScreenElevation"
        : "drwHardwareElevation";
}

// clear (backspace/delete): when the cell holds a drw elevation of this kind, stash an unlink
// intent for onChange/onBulkChange to dispatch and blank the fk optimistically. Returns true when
// it was a drw cell (so the caller skips its legacy clearing).
function clearDrwElevation(kind: DrwAdoptKind, data: any): boolean {
    if(!data[drwElevationField(kind)]) return false;
    data[drwUnlinkField(kind)] = true;
    data[drwElevationField(kind)] = undefined;
    return true;
}

// the clipboard value for a drw elevation cell: the source elevation id tagged by kind, or ""
// when the cell has no drw elevation.
function drwAdoptPayload(kind: DrwAdoptKind, id: number | null | undefined): string {
    return id ? JSON.stringify({__drwAdopt: kind, id}) : "";
}

function parseDrwAdopt(value: string): {kind: DrwAdoptKind; id: number} | null {
    if(!value) return null;
    try {
        const o = JSON.parse(value);
        if((o?.__drwAdopt === "door" || o?.__drwAdopt === "screen" || o?.__drwAdopt === "hardware") && typeof o.id === "number") {
            return {kind: o.__drwAdopt, id: o.id};
        }
    } catch {
        // not a drw payload (e.g. legacy value or plain text)
    }
    return null;
}

// paste: when value is a drw payload, adopt it (if the kind matches this column) and report
// handled so the caller doesn't also write it as a plain value. Returns false for a non-payload
// value (the caller pastes it normally).
function applyDrwAdopt(kind: DrwAdoptKind, data: any, value: string): boolean {
    const a = parseDrwAdopt(value);
    if(!a) return false;
    if(a.kind === kind) data[drwAdoptField(kind)] = a.id;
    return true;
}

// an adopt (paste) or unlink (clear) intent was stashed on the row — onChange/onBulkChange should
// dispatch the drw endpoint(s) instead of a plain opening upsert.
// the filter/sort string for the Screen Elevation cell.
function screenCellString(data: QuoteOpening): string {
    if(data.drwScreenPrimaryOpening) return screenSlotLabel(data);
    return data.drwScreenElevation ? (data.drwScreenElevationName || "") : (data.screenElevation || "");
}

function hasDrwElevationOp(row: any): boolean {
    return !!(row.__adoptDoorElevation || row.__adoptScreenElevation || row.__adoptScreenSlot || row.__adoptHardwareElevation
        || row.__unlinkDoorElevation || row.__unlinkScreenElevation || row.__unlinkHardwareElevation);
}

// the grey text of an elevation cell with no link: "Default" when the opening renders a default.
function defaultCellText(data: QuoteOpening, kind: DrwKind): string {
    return isDrwDefault(data, kind) ? "Default" : "";
}

export function QuoteOpenings() {
    const [tab, setTab, dt] = useTabQueryParam({page: "quote.openings", urlKey: "tab", fallback: "doors", allowed: ["frames", "doors", "all"]});
    const [showSuppliers, setShowSuppliers] = useState(false);

    const u = useUser();
    if(!u) return null;

    if(tab === "review-wall-type") {
        return (
            <QuoteContainer name={<ReviewWallTypeTitle onDone={() => {
                setTab("frames")
            }} />}>
                <ProjectPageTitle title="Wall Types" />
                <ReviewWallTypes />
            </QuoteContainer>
        );
    }

    if(tab === "review-screen-elevation") {
        return (
            <QuoteContainer name={<ReviewScreenElevationTitle onDone={() => {
                setTab("frames")
            }} />}>
                <ProjectPageTitle title="Screen Elevations" />
                <ReviewScreenElevations />
            </QuoteContainer>
        );
    }

    if(tab === "review-door-elevation") {
        return (
            <QuoteContainer name={<ReviewDoorElevationTitle onDone={() => {
                setTab("doors")
            }} />}>
                <ProjectPageTitle title="Door Elevations" />
                <ReviewDoorElevations />
            </QuoteContainer>
        );
    }

    if(tab === "review-drw-screen-elevation") {
        return (
            <QuoteContainer name={<ReviewTitle name="Review Screen Elevations" onDone={() => {
                setTab("frames")
            }} />}>
                <ProjectPageTitle title="Screen Elevations" />
                <ReviewDrwElevations kind="screen" />
            </QuoteContainer>
        );
    }

    if(tab === "review-drw-door-elevation") {
        return (
            <QuoteContainer name={<ReviewTitle name="Review Door Elevations" onDone={() => {
                setTab("doors")
            }} />}>
                <ProjectPageTitle title="Door Elevations" />
                <ReviewDrwElevations kind="door" />
            </QuoteContainer>
        );
    }

    if(tab === "review-drw-hardware-elevation") {
        return (
            <QuoteContainer name={<ReviewTitle name="Review Hardware Elevations" onDone={() => {
                setTab("doors")
            }} />}>
                <ProjectPageTitle title="Hardware Elevations" />
                <ReviewDrwElevations kind="hardware" />
            </QuoteContainer>
        );
    }

    if(tab === "review-frame-profiles" ){
        return (
            <QuoteContainer name={<ReviewTitle name="Review Frame Profiles" onDone={() => {
                setTab("frames")
            }} />}>
                <ProjectPageTitle title="Frame Profiles" />
                <ReviewFrameProfiles />
            </QuoteContainer>
        );
    }

    if(tab === "review-anchors" ){
        return (
            <QuoteContainer name={<ReviewTitle name="Review Anchors" onDone={() => {
                setTab("frames")
            }} />}>
                <ProjectPageTitle title="Anchors" />
                <ReviewAnchors />
            </QuoteContainer>
        );
    }

    if(tab === "review-door-core") {
        return (
            <QuoteContainer name={<ReviewTitle name="Review Door Core" onDone={() => {
                setTab("doors")
            }} />}>
                <ProjectPageTitle title="Door Core" />
                <ReviewDoorCore />
            </QuoteContainer>
        );
    }

    if(tab === "review-door-seam") {
        return (
            <QuoteContainer name={<ReviewTitle name="Review Door Seam" onDone={() => {
                setTab("doors")
            }} />}>
                <ProjectPageTitle title="Door Seam" />
                <ReviewDoorSeam />
            </QuoteContainer>
        );
    }

    if(tab === "wood-details" ){
        return (
            <QuoteContainer name={<ReviewTitle name="Wood Details" onDone={() => {
                setTab("doors")
            }} />}>
                <ProjectPageTitle title="Wood Details" />
                <WoodDetails />
            </QuoteContainer>
        );
    }

    return <SupplierProvider><QuoteContainer name={<OpeningSwitcher />} actions={
        <div>
            <Grid container spacing={1}>
                <Grid item>
                    <MakeQuoteSubmittal />
                </Grid>
                <SubmittalsMenu />
                <Grid item>
                    <QuoteSubmittalHistory />
                </Grid>
            </Grid>
        </div>
    } overrideRightActions={<>
        <HeaderActionButton
            label="Suppliers"
            icon={<StorefrontIcon fontSize="inherit" />}
            badgeContent={null}
            onClick={() => setShowSuppliers(true)}
        />
        {showSuppliers && <ManageProjectSuppliers onDone={() => setShowSuppliers(false)} />}
    </>}>
        <ProjectPageTitle title="Openings" />
        <ProjectPropertiesProvider>
            <ElevationSidebarProvider>
            <div style={{
                flex: 1, display: "flex",
                flexDirection: "row",
                overflow: "hidden",
            }}>
            <div style={{
                padding: 0,
                flex: 1, minWidth: 0, display: "flex",
                flexDirection: "column",
                overflow: "auto"
            }}>
                <TabWrapper>
                    <Tabs value={tab} onChange={(e, value) => {
                        setTab(value)
                    }}>
                        <Tab label="Frames" value="frames" {...dt.tabProps("frames")} />
                        <Tab label="Doors" value="doors" {...dt.tabProps("doors")} />
                        <Tab label="All" value="all" {...dt.tabProps("all")} />
                    </Tabs>
                    {dt.controls}
                </TabWrapper>

                <BreakHardwareLinkProvider>
                    <ConfirmAdoptIdentityProvider>
                        <QuoteOpeningTable tab={tab} onTabChange={setTab} />
                    </ConfirmAdoptIdentityProvider>
                </BreakHardwareLinkProvider>
            </div>
            <ElevationSidebar quote />
            </div>
            <UnlessElevationSidebarOpen><ProjectProperties /></UnlessElevationSidebarOpen>
            </ElevationSidebarProvider>
        </ProjectPropertiesProvider>
    </QuoteContainer></SupplierProvider>
}

export let currentQuoteTab = "";

function QuoteOpeningTable(props: {
    tab: string;
    onTabChange(value: string): void
}) {
    const {tab} = props;
    const project = useProjectId();
    const alternative = useAlternative();
    const nav = useNavigate();
    const showDoor = (tab === "doors" || tab === "all");
    const showFrame = (tab === "frames" || tab === "all");
    const tableName = quoteOpeningsTableName(project, tab);
    const tableName2 = quoteOpeningsTableName(0, tab);
    const [key] = useState("-")
    const hwContext = useContext(BreakHardwareLinkContext);
    const {openingAutoFill} = useContext(ProjectPropertiesContext)
    const proj = useProject();

    const locked = proj?.quoteLockedOpenings === alternative

    currentQuoteTab = tab;

    const sys = useProjectUnitSystem();
    console.log("sys", sys)

    const ddl = useContext(DropDownContext);
    const frameProfileOptions = useDropdownData(ddl.frameProfiles);
    const doorCoreOptions = useDropdownData(ddl.doorCores);
    const doorSeamOptions = useDropdownData(ddl.doorSeam);
    const doorMaterialOptions = useDropdownData(ddl.doorMaterial);
    const doorFinishOptions = useDropdownData(ddl.doorMaterialWoodFinish);
    const shortCodeSearch = useShortCodeSearch();
    const adoptIdentityConfirm = useConfirmAdoptIdentity();
    const confirm = useConfirm();

    // dispatch drw elevation adopt (paste) / unlink (clear) intents stashed on a row (see the drw
    // helpers). Returns true when at least one ran, so the caller reloads instead of upserting.
    const applyDrwElevationOps = async (row: any): Promise<boolean> => {
        let did = false;
        if(row.__adoptDoorElevation) {
            await api.elevationTool.adoptDoor({project, quoteOpening: row.id, door: row.__adoptDoorElevation});
            did = true;
        }
        if(row.__adoptScreenElevation) {
            // adopting a screen overwrites opening properties (handing etc.) to match the
            // elevation; when the server reports the diff instead of saving, prompt (update
            // the opening, or link a private copy when offered), then re-send with the
            // resolution. On cancel nothing was saved — the reload reverts the cell.
            const res = await api.elevationTool.adoptScreen({project, quoteOpening: row.id, screen: row.__adoptScreenElevation});
            if(res.identityChanges?.length) {
                const resolution = await adoptIdentityConfirm.confirm(res.identityChanges, !!res.canCopy);
                if(resolution) {
                    await api.elevationTool.adoptScreen({project, quoteOpening: row.id, screen: row.__adoptScreenElevation, confirm: resolution === "update", copy: resolution === "copy"});
                }
            }
            did = true;
        }
        if(row.__adoptScreenSlot) {
            await api.elevationTool.adoptScreenSlot({project, quoteOpening: row.id, ...row.__adoptScreenSlot});
            did = true;
        }
        if(row.__adoptHardwareElevation) {
            await adoptHardwareElevation(confirm.confirm, {project, quoteOpening: row.id, hardware: row.__adoptHardwareElevation});
            did = true;
        }
        if(row.__unlinkDoorElevation) {
            await api.elevationTool.unlinkDoor({project, quoteOpening: row.id});
            did = true;
        }
        if(row.__unlinkScreenElevation) {
            await api.elevationTool.unlinkScreen({project, quoteOpening: row.id});
            did = true;
        }
        if(row.__unlinkHardwareElevation) {
            await api.elevationTool.unlinkHardware({project, quoteOpening: row.id});
            did = true;
        }
        return did;
    };

    if(ddl.loading || !sys) {
        return <CircularProgress />
    }

    return (
        <CheckboxProvider>
            <Table<QuoteOpening>
                key={key + tab}
                locked={false}
                name={tableName}
                globalPrefsName={tableName2}
                onDrag={async (input) => {
                    await api.quoteOpenings.reOrder({
                        project: project,
                        alternative: alternative,
                        idOrder: input.idOrder,
                    })

                    return {
                        sortByCol: null
                    }
                }}
                cellCustomize={{
                    backgroundColor: (row: QuoteOpening) => {
                        if(locked) return grey["100"]
                        return undefined;
                    },
                    onFocus: (row: QuoteOpening, c: Column<QuoteOpening>) => <ElevationCellFocusReporter row={row} column={c} />,
                    onFocusLocked: (row: QuoteOpening, c: Column<QuoteOpening>) => <ElevationCellFocusReporter row={row} column={c} />,
                }}
                columns={[{
                    name: actionsColName,
                    noCsv: true,
                    render: o => <RowActions row={o} />,
                    renderName: () => <OpeningBulkActions />,
                    width: 200,
                },
                    SeqNumber("seqNumber", tableName, (ids) => api.quoteOpenings.reSequence({
                        project: project,
                        alternative: alternative,
                        idOrder:ids,
                    })),
                    StringCol("Opening", "name"),
                    NumberCol("Qty", "qty"),
                    StringCol("Floor", "floor"),
                    PhaseCol<QuoteOpening>(),
                    Checkbox2Col("Ext", "exterior"),
                    StringCol("Location", "locationOne"),
                    Select2Col<QuoteOpening>("To/From", "locationTransition", locationTransitions),
                    StringCol<QuoteOpening>("Location 2", "locationTwo"),
                    AdjustCol(Select2Col<QuoteOpening>("Type", "openingType", openingTypes), {
                        editable: {
                            type: "select",
                            options: () => openingTypes.map(o => ({
                                display: o,
                                value: o,
                            })),
                            onChangeBeforeSave: (row: QuoteOpening, value: string) => {
                                row.nominalWidth = "";
                                row.inactiveDoorWidth = "";
                                row.handing = "";
                            }
                        }
                    }),
                    NominalWidth<QuoteOpening>("Nominal Width", sys, "nominalWidth", "inactiveDoorWidth"),
                    DistanceCol("Nominal Height", sys, "nominalHeight"),
                    AdjustCol(StringCol("Hand", "handing"), {
                        editable: {
                            type: "select",
                            options: handingOptions as any,
                            onChangeBeforeSave: (row: QuoteOpening, value: string) => {
                                updateFrameProfileBasedOnHanding(row)
                            }
                        },
                        disabled: isWindow as any,
                    }),
                    Select2Col<QuoteOpening>("Label", "label", labels),
                    showFrame && AdjustCol(Select2Col<QuoteOpening>("Frame Series", "frameSeries", frameSeries), {
                        renderName: () => <FrameSeriesHeader />,
                        render: (data: QuoteOpening) => (
                            <div style={{display: "flex", position: "relative"}}>
                                <div style={{flex: 1}}>{data.frameSeries}</div>
                                <FrameByOthersCell data={data} />
                            </div>
                        ),
                        width: 150,
                        editable: {
                            type: "select",
                            getValue: (o: QuoteOpening) => o.frameSeries,
                            options: () => frameSeries.map(o => ({display: o, value: o})),
                            onChangeBeforeSave: (row: QuoteOpening, value: string) => applyFrameSeriesByOthers(row, value),
                            copy: copyFrameSeries,
                            paste: pasteFrameSeries,
                        },
                    }),
                    showFrame && SelectCol<QuoteOpening>("Frame Material", "frameMaterial", frameMaterial),
                    showFrame && AdjustCol(SelectCol<QuoteOpening>("Frame Gauge", "frameGauge", frameGauge), {
                        alignRight: true,
                    }),
                    showFrame && {
                        name: elevationColumnNames.screen,
                        renderName: () => <ScreenElevationHeader />,
                        // legacy quote openings (file-based screen elevation, no drw link) keep the
                        // popup editor. Everything else — blank or already on a drw elevation — gets the
                        // autocomplete to pick an existing drw screen elevation (adopts its identity) on
                        // cell click (the icon still opens the tool; see render).
                        editableFunc: (row: QuoteOpening) => {
                            const isNew = !!row.drwScreenElevation || !!row.drwScreenPrimaryOpening;
                            const isLegacy = !isNew && !!row.screenElevation;

                            if(!isLegacy) {
                                return {
                                    editable: {
                                        type: "custom",
                                        // copy the linked screen id, or the frame slot of a secondary opening;
                                        // paste adopts it server-side (see applyDrwElevationOps).
                                        copy: (data: QuoteOpening) => data.drwScreenPrimaryOpening ? screenSlotPayload(data) : drwAdoptPayload("screen", data.drwScreenElevation),
                                        paste: (data: any, value: string) => {
                                            if(value === "") {
                                                clearScreenSlot(data);
                                                clearDrwElevation("screen", data);
                                                return;
                                            }

                                            const slot = parseScreenSlotPayload(value);
                                            if(slot) { data.__adoptScreenSlot = slot; return; }
                                            applyDrwAdopt("screen", data, value);
                                        },
                                        render: (props: any) => <PickScreenElevation {...props} alternative={alternative} />,
                                    },
                                };
                            }

                            return {
                                editable: {
                                    type: "custom",
                                    copy: (data: QuoteOpening) => data.screenElevation?.toString() || "",
                                    paste: (data: any, value: string) => {
                                        // pasting a copied drw screen elevation or frame slot onto a legacy cell adopts it.
                                        const slot = parseScreenSlotPayload(value);
                                        if(slot) { data.__adoptScreenSlot = slot; return; }
                                        if(applyDrwAdopt("screen", data, value)) return;
                                        data.screenElevation = value;
                                        data.screenElevationFile = undefined;
                                    },
                                    render: (props: any) => <ScreenElevationPopup {...props} />,
                                    fileDropAccept: ["application/pdf", "image/*"],
                                    fileDropAction: async (files: any, info: any) => {
                                        const fileObj = await api.files.upload({
                                            file: files[0],
                                            // use guid naming to prevent collisions
                                            name: window.crypto.randomUUID() + ext(files[0].name),
                                            convert2pdf: true,
                                        });

                                        info.update(Object.assign({}, info.row, {
                                            screenElevationFile: fileObj.id,
                                        }));
                                    },
                                },
                            };
                        },
                        editObj: (dst, src, value: string) => {
                            // backspace/delete on the cell clears everything: unlink a drw screen
                            // elevation (via clearDrwElevation) and clear the legacy value.
                            if(!value) {
                                clearScreenSlot(dst);
                                clearDrwElevation("screen", dst);
                            }

                            dst.screenElevation = value;
                            dst.screenElevationFile = undefined;
                        },
                        render: (data, col) => {
                            // a secondary opening fills a door slot on its primary's frame.
                            if(data.drwScreenPrimaryOpening) {
                                return <div><span style={{color: grey["500"]}}>Frame of </span>{screenSlotLabel(data)}</div>;
                            }

                            const isNew = !!data.drwScreenElevation;
                            const isLegacy = !isNew && !!data.screenElevation;

                            const url = `/project/${project}/quote/${alternative}/elevation-tool?quoteOpening=${data.id}&alternative=${alternative}&workspace=screen`;

                            const iconLink = (icon: any, title: string) => (
                                <Tooltip title={title}>
                                    <a href={url} onClick={e => openElevation(e, nav, url)}
                                       style={{color: grey["500"], display: "inline-flex", marginLeft: 4}}>
                                        {icon}
                                    </a>
                                </Tooltip>
                            );

                            // legacy: name is edited via the popup on click; the convert icon jumps into
                            // the new elevation tool.
                            if(isLegacy) {
                                return (
                                    <div style={{display: "flex", position: "relative", alignItems: "center"}}>
                                        <div style={{flex: 1}}>{data.screenElevation || ""}</div>
                                        {iconLink(<ChangeCircleOutlined style={{fontSize: "0.9rem"}}/>, "Convert to elevation tool")}
                                    </div>
                                )
                            }

                            // drw or blank: clicking the cell opens the pick-an-existing-screen autocomplete
                            // (see editableFunc). The icon opens the tool — to view the linked drawing, or
                            // draw one from scratch.
                            return (
                                <div style={{display: "flex", position: "relative", alignItems: "center"}}>
                                    <div style={{flex: 1, color: isNew ? "inherit" : grey["500"]}}>{isNew ? (data.drwScreenElevationName || "") : defaultCellText(data, "screen")}</div>
                                    {isNew
                                        ? iconLink(<OpenInNew style={{fontSize: "0.9rem"}}/>, "Open in elevation tool")
                                        : iconLink(<NoteAddOutlined style={{fontSize: "0.9rem"}}/>, "Draw new elevation")}
                                </div>
                            )
                        },
                        headerMenuItems: () => {
                            return [{
                                name: "Review Screen Elevations",
                                onClick: () => {
                                    props.onTabChange("review-drw-screen-elevation")
                                }
                            }, {
                                name: "Review Screen Elevations (File-based)",
                                onClick: () => {
                                    props.onTabChange("review-screen-elevation")
                                }
                            }]
                        },
                        filter: (data, search) => {
                            return screenCellString(data).toLowerCase().startsWith(search.toLowerCase())
                        },
                        sort: (a, b) => {
                            return sortStringInner(screenCellString(a), screenCellString(b))
                        }
                    },
                    showFrame && AdjustCol(SelectCol<QuoteOpening>("Frame Profile", "frameProfile", makeSelectWrapper(frameProfileOptions)), {
                        headerMenuItems: () => {
                            return [{
                                name: "Review Frame Profiles",
                                onClick: () => {
                                    props.onTabChange("review-frame-profiles")
                                }
                            }]
                        },
                    }),
                    showFrame && {
                        name: "Wall Type",
                        renderName: () => <WallTypeHeader />,
                        editable: {
                            type: "custom",
                            copy: data => data.drawingWallLabel?.toString() || "",
                            paste: (data, value) => {
                                data.drawingWallLabel = value;
                            },
                            render: (props) => {
                                if(!props.row.drawingWallLabel) {
                                    return (
                                        <TextEditCell keyName="drawingWallLabel" {...props} />
                                    )
                                }

                                return <DrawingWallLabelPopup {...props} />
                            },
                            fileDropAccept: ["application/pdf", "image/*"],
                            fileDropAction: async (files, info) => {
                                const fileObj = await api.files.upload({
                                    file: files[0],
                                    // use guid naming to prevent collisions
                                    name: window.crypto.randomUUID() + ext(files[0].name),
                                    convert2pdf: true,
                                });

                                info.update(Object.assign({}, info.row, {
                                    drawingWallLabelFile: fileObj.id,
                                }))
                            },
                        },
                        editObj: (dst, src, value: string) => {
                            dst.drawingWallLabel = value;
                            dst.drawingWallLabelFile = undefined;
                        },
                        render: (data, col) => {
                            return data.drawingWallLabel || "";
                        },
                        width: 100,
                        headerMenuItems: () => {
                            return [{
                                name: "Review Wall Types",
                                onClick: () => {
                                    props.onTabChange("review-wall-type")
                                }
                            }]
                        },
                        filter: (data, search) => {
                            return (data.drawingWallLabel || "").toLowerCase().startsWith(search.toLowerCase())
                        },
                        sort: (a, b) => {
                            return sortStringInner(a.drawingWallLabel || "", b.drawingWallLabel || "")
                        }
                    },
                    showFrame && JambDepthCol("Jamb Depth", "jambDepth"),
                    showFrame && SelectCol<QuoteOpening>("Frame Construction", "frameConstruction", frameConstruction),
                    showFrame && AnchorCol<QuoteOpening>({
                        onTabChange: v => props.onTabChange(v),
                        elevationUrl: data => `/project/${project}/quote/${alternative}/elevation-tool?quoteOpening=${data.id}&alternative=${alternative}&workspace=screen`,
                    }),
                    showDoor && AdjustCol(Select2Col<QuoteOpening>("Door Series", "doorSeries", doorSeries), {
                        disabled: isWindow as any,
                        renderName: () => <DoorSeriesHeader />,
                        render: (data: QuoteOpening) => (
                            <div style={{display: "flex", position: "relative"}}>
                                <div style={{flex: 1}}>{data.doorSeries}</div>
                                <DoorByOthersCell data={data} />
                            </div>
                        ),
                        width: 150,
                        editable: {
                            type: "select",
                            getValue: (o: QuoteOpening) => o.doorSeries,
                            options: () => doorSeries.map(o => ({display: o, value: o})),
                            onChangeBeforeSave: (row: QuoteOpening, value: string) => applyDoorSeriesByOthers(row, value),
                            copy: copyDoorSeries,
                            paste: pasteDoorSeries,
                        },
                    }),
                    showDoor && AdjustCol(SelectCol<QuoteOpening>("Door Material", "doorMaterial", makeSelectWrapper(doorMaterialOptions, ddlDoorSeriesFilter)), {
                        disabled: isWindow as any,
                        headerMenuItems: () => {
                            return [{
                                name: "Review Wood Materials",
                                onClick: () => {
                                    props.onTabChange("wood-details")
                                }
                            }]
                        },
                    }),
                    showDoor && AdjustCol(SelectCol<QuoteOpening>("Door Finish", "doorFinish", makeSelectWrapper(doorFinishOptions, ddlDoorSeriesFilter), {
                        freeSolo: true
                    }), {
                        disabled: isWindow as any,
                    }),
                    showDoor && AdjustCol(SelectCol<QuoteOpening>("Door Gauge", "doorGauge", doorGauge), {
                        alignRight: true,
                        disabled: isWindow as any,
                    }),
                    showDoor && AdjustCol(SelectCol<QuoteOpening>("Door Thickness", "doorThickness", makeSelectWrapper(doorThicknesses(sys).map(v => ({display: v, value: v}))), {
                        freeSolo: true,
                        parseValue: (raw, str) => cleanDoorThickness(sys, str),
                        validate: (str) => validateDoorThickness(sys, str),
                    }), {
                        disabled: isWindow as any,
                    }),
                    showDoor && AdjustCol<QuoteOpening>({
                        name: elevationColumnNames.door,
                        width: 200,
                        renderName:() => {
                            return <DoorElevationColumnHeader />
                        },
                        renderFilter: (props) => {
                            return <DoorElevationFilter {...props} />
                        },
                        // legacy quote openings (file-based door elevation, no drw link) keep the popup
                        // editor. Everything else — blank or already on a drw elevation — gets the
                        // autocomplete to pick an existing drw door elevation on cell click.
                        editableFunc: (row: QuoteOpening) => {
                            const isNew = !!row.drwDoorElevation;
                            const isLegacy = !isNew && (!!row.doorElevation || !!row.doorElevationFile);

                            if(!isLegacy) {
                                return {
                                    editable: {
                                        type: "custom",
                                        // copy the linked door id; paste adopts it server-side (see applyDrwElevationOps).
                                        copy: (data: QuoteOpening) => drwAdoptPayload("door", data.drwDoorElevation),
                                        paste: (data: any, value: string) => {
                                            if(value === "") { clearDrwElevation("door", data); return; }
                                            applyDrwAdopt("door", data, value);
                                        },
                                        render: (props: any) => <PickDoorElevation {...props} alternative={alternative} />,
                                    },
                                };
                            }

                            return {
                                editable: {
                                    type: "custom",
                                    copy: (data: QuoteOpening) => JSON.stringify({
                                        doorElevation: data.doorElevation,
                                        inactiveDoorElevation: data.inactiveDoorElevation
                                    }),
                                    paste: (data: any, value: string) => {
                                        // pasting a copied drw door elevation onto a legacy cell adopts it.
                                        if(applyDrwAdopt("door", data, value)) return;
                                        if(!value) return; // blank source — nothing to paste
                                        const obj = JSON.parse(value) as {doorElevation: string, inactiveDoorElevation: string}
                                        data.doorElevation = obj.doorElevation
                                        data.doorElevationFile = undefined
                                        data.inactiveDoorElevation = obj.inactiveDoorElevation
                                        data.inactiveDoorElevationFile = undefined
                                    },
                                    fileDropAccept: ["application/pdf", "image/*"],
                                    fileDropAction: async (files: any, info: any) => {
                                        const fileObj = await api.files.upload({
                                            file: files[0],
                                            // use guid naming to prevent collisions
                                            name: window.crypto.randomUUID() + ext(files[0].name),
                                            convert2pdf: true,
                                        });

                                        info.update(Object.assign({}, info.row, {
                                            doorElevationFile: fileObj.id,

                                            inactiveDoorElevation: "",
                                            inactiveDoorElevationFile: undefined,
                                        }))
                                    },
                                    render: (props: any) => {
                                        return <DoorElevationSelector {...props} quoteMode={true} />
                                    }
                                },
                            };
                        },
                        editObj: (dst, src, value: string) => {
                            if(value === "") {
                                clearDrwElevation("door", dst); // unlink a drw door elevation, if linked
                                dst.doorElevation = ""
                                dst.doorElevationFile = undefined;
                                dst.inactiveDoorElevation = ""
                                dst.inactiveDoorElevationFile = undefined;
                            } else {
                                throw new Error("unsupported action")
                            }
                        },
                        render: (data, col) => {
                            const isNew = !!data.drwDoorElevation;
                            const isLegacy = !isNew && (!!data.doorElevation || !!data.doorElevationFile);

                            const url = `/project/${project}/quote/${alternative}/elevation-tool?quoteOpening=${data.id}&alternative=${alternative}&workspace=door`;

                            const iconLink = (icon: any, title: string) => (
                                <Tooltip title={title}>
                                    <a href={url} onClick={e => openElevation(e, nav, url)}
                                       style={{color: grey["500"], display: "inline-flex", marginLeft: 4}}>
                                        {icon}
                                    </a>
                                </Tooltip>
                            );

                            if(isLegacy) {
                                return (
                                    <div style={{display: "flex", position: "relative", alignItems: "center"}}>
                                        <div style={{flex: 1}}><DoorElevationCell data={data} /></div>
                                        {iconLink(<ChangeCircleOutlined style={{fontSize: "0.9rem"}}/>, "Convert to elevation tool")}
                                    </div>
                                )
                            }

                            return (
                                <div style={{display: "flex", position: "relative", alignItems: "center"}}>
                                    <div style={{flex: 1, position: "relative", color: isNew ? "inherit" : grey["500"]}}>
                                        {isNew ? (data.drwDoorElevationName || "") : defaultCellText(data, "door")}
                                        {isNew && <DrwDoorThermalCheckbox checked={!!data.drwDoorThermal} />}
                                    </div>
                                    {isNew
                                        ? iconLink(<OpenInNew style={{fontSize: "0.9rem"}}/>, "Open in elevation tool")
                                        : iconLink(<NoteAddOutlined style={{fontSize: "0.9rem"}}/>, "Draw new elevation")}
                                </div>
                            )
                        },
                        filter: (data, search) => {
                            const name = data.drwDoorElevation ? (data.drwDoorElevationName || "") : renderDoorElevationStr(data, false);
                            return name.toLowerCase().startsWith(search.toLowerCase())
                        },
                        sort: (a, b) => {
                            const an = a.drwDoorElevation ? (a.drwDoorElevationName || "") : renderDoorElevationStr(a, false);
                            const bn = b.drwDoorElevation ? (b.drwDoorElevationName || "") : renderDoorElevationStr(b, false);
                            return sortStringInner(an, bn)
                        },
                        headerMenuItems: () => {
                            return [{
                                name: "Review Door Elevations",
                                onClick: () => {
                                    props.onTabChange("review-drw-door-elevation")
                                }
                            }, {
                                name: "Review Door Elevations (File-based)",
                                onClick: () => {
                                    props.onTabChange("review-door-elevation")
                                }
                            }]
                        }
                    }, {
                        disabled: isWindow as any,
                    }),
                    showDoor && AdjustCol(SelectCol<QuoteOpening>("Door Core", "doorCore", makeSelectWrapper(doorCoreOptions, ddlDoorSeriesFilter)), {
                        disabled: isWindow as any,
                        headerMenuItems: () => {
                            return [{
                                name: "Review Door Cores",
                                onClick: () => {
                                    props.onTabChange("review-door-core")
                                }
                            }]
                        },
                    }),
                    showDoor && AdjustCol(SelectCol<QuoteOpening>("Door Seam", "doorSeam", makeSelectWrapper(doorSeamOptions, ddlDoorSeriesFilter)), {
                        disabled: isWindow as any,
                        headerMenuItems: () => {
                            return [{
                                name: "Review Door Seams",
                                onClick: () => {
                                    props.onTabChange("review-door-seam")
                                }
                            }]
                        },
                    }),
                    PrepLocationCol<QuoteOpening>(),
                    AdjustCol<QuoteOpening>({
                        name: elevationColumnNames.hardware,
                        width: 200,
                        editable: {
                            type: "custom",
                            // copy the linked hardware id; paste adopts it server-side (see applyDrwElevationOps).
                            copy: (data: QuoteOpening) => drwAdoptPayload("hardware", data.drwHardwareElevation),
                            paste: (data: any, value: string) => {
                                if(value === "") { clearDrwElevation("hardware", data); return; }
                                applyDrwAdopt("hardware", data, value);
                            },
                            render: (props: any) => <PickHardwareElevation {...props} alternative={alternative} />,
                        },
                        // backspace/delete unlinks a drw hardware elevation (single-cell clear goes through
                        // editObj, not editable.paste).
                        editObj: (dst, src, value: string) => {
                            if(value === "") clearDrwElevation("hardware", dst);
                        },
                        render: (data, col) => {
                            const isNew = !!data.drwHardwareElevation;
                            const url = hardwareElevationToolUrl({project, opening: data.id, alternative});

                            const iconLink = (icon: any, title: string) => (
                                <Tooltip title={title}>
                                    <a href={url} onClick={e => openElevation(e, nav, url)}
                                       style={{color: grey["500"], display: "inline-flex", marginLeft: 4}}>
                                        {icon}
                                    </a>
                                </Tooltip>
                            );

                            return (
                                <div style={{display: "flex", position: "relative", alignItems: "center"}}>
                                    <div style={{flex: 1, color: isNew ? "inherit" : grey["500"]}}>{isNew ? (data.drwHardwareElevationName || "") : defaultCellText(data, "hardware")}</div>
                                    {isNew
                                        ? iconLink(<OpenInNew style={{fontSize: "0.9rem"}}/>, "Open in elevation tool")
                                        : iconLink(<NoteAddOutlined style={{fontSize: "0.9rem"}}/>, "Draw new elevation")}
                                </div>
                            )
                        },
                        filter: (data, search) => {
                            return (data.drwHardwareElevationName || "").toLowerCase().startsWith(search.toLowerCase())
                        },
                        sort: (a, b) => {
                            return sortStringInner(a.drwHardwareElevationName || "", b.drwHardwareElevationName || "")
                        },
                        headerMenuItems: () => {
                            return [{
                                name: "Review Hardware Elevations",
                                onClick: () => {
                                    props.onTabChange("review-drw-hardware-elevation")
                                }
                            }]
                        },
                    }, {
                        disabled: isWindow as any,
                    }),
                    {
                        name: "Hardware Heading",
                        width: 200,
                        render: (data, col) => {
                            return data.hardwareGroupName || ""
                        },
                        editable: {
                            type: "button",
                            render: props => <EditHardwareGroup isQuote {...props} />
                        },
                        filter: (data, search) => {
                            return data.hardwareGroupName?.indexOf(search) === 0
                        },
                        sort: (a, b) => {
                            return sortStringInner(a.hardwareGroupName || "", b.hardwareGroupName || "")
                        },
                        disabled: isWindow as any,
                    },
                    {
                        name: "HW Shortcode",
                        width: 150,
                        render: (data) => {
                            return data.hardwareGroupShortcodeName || ""
                        },
                        filter: (data, search) => {
                            return data.hardwareGroupShortcodeName && data.hardwareGroupShortcodeName.toLowerCase().indexOf(search.toLowerCase()) !== -1
                        },
                        sort: (a, b) => {
                            return sortStringInner(a.hardwareGroupShortcodeName || "", b.hardwareGroupShortcodeName || "")
                        },
                        editKey: "hardwareGroupShortcodeName",
                        editable: {
                            type: "lookup",
                            displayKey: "hardwareGroupShortcodeName",
                            options: async (search: string) => {
                                return shortCodeSearch.current(search)
                            },
                        },
                        disabled: isWindow as any,
                    },
                ]}
                fetch={(ctx, ids) => {
                    return getAll(ctx, offset => api.quoteOpenings.list({
                        ids: ids?.join(","),
                        project: project, offset,
                        alternative: alternative,
                    }), {useLazy: !!ids})
                }}
                fetchDeps={[project, alternative, locked]}
                insert={{
                    buttonText: "New Row",
                    alignX: "left",
                    modal: input => <AutoInsertOpening onDone={input} />,
                    options: () => <NewRowMenu />,
                }}
                onChange={async (input, previous) => {
                    // elevation copy/paste + clear (single cell): adopt/unlink via the drw endpoints,
                    // not the plain quote-opening upsert.
                    if(hasDrwElevationOp(input)) {
                        await applyDrwElevationOps(input);
                        return null; // reload to show the linked/cleared elevation
                    }

                    try {
                        input = openingAutoFill(input, previous);
                        return await api.quoteOpenings.upsert(input)
                    } catch (e: any) {
                        return await hwContext.onError(input, e, async (input) => {
                            return await api.quoteOpenings.upsert(input)
                        });
                    }
                }}
                onBulkChange={async (input, prev) => {
                    // elevation copy/paste column-fill: adopt each target via the drw endpoints (never
                    // the plain upsert — screen adopts identity, hardware clones). Rows without an adopt
                    // intent upsert as usual.
                    let didDrwOp = false;
                    const rows: QuoteOpening[] = [];
                    for(let i = 0; i < input.length; i++) {
                        if(hasDrwElevationOp(input[i])) {
                            await applyDrwElevationOps(input[i]);
                            didDrwOp = true;
                        } else {
                            rows.push(openingAutoFill(input[i], prev[i]));
                        }
                    }

                    const result = rows.length > 0 ? await api.quoteOpenings.upsertBulk(rows) : null;
                    // adopt/unlink change rows server-side without returning ids; force a full reload.
                    return didDrwOp ? null : result;
                }}
            />
        </CheckboxProvider>
    )
}

export function updateFrameProfileBasedOnHanding<T extends (Opening|QuoteOpening)>(row: T) {
    if(row.frameProfile) return;

    switch(row.handing) {
        case "LH-DA":
        case "RH-DA":
        case "CO":
        case "LH-BARN":
        case "RH-BARN":
        case "LH-BIFOLD":
        case "RH-BIFOLD":
        case "LHA-DA":
        case "RHA-DA":
        case "LHA/RHA-DA":
        case "DBL BYPASS":
        case "DBL BIFOLD":
            row.frameProfile = "CO"
            break;
        case "LH-POCKET":
        case "RH-POCKET":
        case "DBL POCKET":
            row.frameProfile = "PO"
            break;
        case "LHLH-COMM":
        case "RHRH-COMM":
        case "LHRH-COMM":
            row.frameProfile = "COMM"
            break;
        case "LHR/LHR":
        case "RHR/RHR":
            row.frameProfile = "DE"
            break;
    }
}

export const isWindow = (input: QuoteOpening | Opening) => input.openingType === openingTypeWindow;
export const openingTypeWindow = "Window";

const prepCustom = "Custom"
const prepStandard = "Standard"

// usesGroupPreps reports whether the opening takes any prep entry from its hardware group. An opening
// whose cuts and hardware all come from drw elevations has nothing to edit in the group's preps.
export function usesGroupPreps(data: QuoteOpening | Opening) {
    const from = data.prepFromGroup;
    if(!from) return true;
    return from.overCutDoor || from.underCutDoor || from.underCutFrame || from.hardware;
}

export function PrepLocationCol<T extends (QuoteOpening | Opening)>(): Column<T> {
    return {
        name: "Prep Locations",
        width: 250,
        disabled: (data: T) => isWindow(data) || !usesGroupPreps(data),
        render: (data: T, col: any) => {
            if(data.openingType === openingTypeWindow) return null;

            if(!data.prepIsCustom) return <div style={{fontStyle: "italic", textDecoration: "underline"}}>{prepStandard}</div>
            return <div style={{fontStyle: "italic", textDecoration: "underline"}}>{prepCustom}</div>
        },
        isChangedSinceBackup: (a: T) => {
            // @ts-ignore
            if(!a.backup) return false;

            // @ts-ignore
            if(!a.hardwareGroupPrepConfigIsCustom && !a.backup.hardwareGroupPrepConfigIsCustom) return false;

            const before = a.hardwareGroupPrepConfig || [];
            // @ts-ignore
            const after = a.backup.hardwareGroupPrepConfig || []

            const merged = mergeArrayByKey(before, after, v => v.name)
            return merged.some(v => !objEq(v.before, v.after))
        },
        editable: {
            type: "button",
            render: (props) => <PrepLocations value={props.row} onDone={props.onDone} onCancel={props.onCancel} />,
        },
        sort: (a, b) => {
            return sortStringInner(renderPrepLocationString(a), renderPrepLocationString(b))
        },
        filter: (data, search) => {
            return renderPrepLocationString(data).toLowerCase().startsWith(search.toLowerCase())
        }
    }
}

function renderPrepLocationString<T extends (Opening|QuoteOpening)>(data: T) {
    if(data.openingType === openingTypeWindow) return "";
    if(!data.prepIsCustom) return prepStandard
    return prepCustom
}

function objEq<T extends object>(a: T | undefined, b: T | undefined) {
    if(a === b) return true;
    if(!a || !b) return false;

    const keys = new Set([...Object.keys(a), ...Object.keys(b)]);

    for(const k of Array.from(keys)) {
        // @ts-ignore
        if(a[k] !== b[k]) return false;
    }

    return true;
}

function mergeArrayByKey<T>(before: T[], after: T[], key: (v: T) => string) {
    const beforeMap = new Map<string, T>();
    for(const v of before) {
        beforeMap.set(key(v), v);
    }

    const afterMap = new Map<string, T>();
    for(const v of after) {
        afterMap.set(key(v), v);
    }

    const keys = new Set([...Array.from(beforeMap.keys()), ...Array.from(afterMap.keys())]);
    const out: {key: string; before?: T, after?: T}[] = [];

    for(const k of Array.from(keys)) {
        const a = afterMap.get(k);
        const b = beforeMap.get(k);

        out.push({
            key: k,
            before: b,
            after: a,
        })
    }

    return out;
}

export function hasCustomPrep(input: PrepDetail[] | undefined) {
    if(!input) return false;

    const customizations = input.filter(v => !!v.value);
    return customizations.length > 0
}

export function AnchorCol<T extends (QuoteOpening | Opening)>(props?: {
    disableQty?: boolean
    onTabChange?(tab: string): void;
    // the screen workspace of the elevation tool for the opening, linked when the drawing owns the anchors.
    elevationUrl?(data: T): string;
}): Column<T> {
    const onTabChange = props?.onTabChange;

    return {
        name: "Anchor",
        width: 250,
        render: (data: T, col: any) => {
            if(data.drwHasAnchors) {
                const text = (data.drwAnchorSummary ? data.drwAnchorSummary + " " : "") + "(screen)";
                if(!props?.elevationUrl) return text;

                return (
                    <div style={{display: "flex", alignItems: "center"}}>
                        <div style={{flex: 1}}>{text}</div>
                        <AnchorElevationLink url={props.elevationUrl(data)} />
                    </div>
                );
            }
            if(!data.frameAnchorProductName) return "";

            return (
                <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                    <div>
                        {data.frameAnchorProductName}
                    </div>
                    {props?.disableQty ? null : <AnchorQty data={data} />}
                </div>
            );
        },
        headerMenuItems: onTabChange ? () => {
            return [{
                name: "Review Anchors",
                onClick: () => {
                    if(onTabChange) onTabChange("review-anchors");
                }
            }]
        } : undefined,
        // the drawing's anchors replace the column, so they're edited in the elevation tool.
        disabled: data => data.drwHasAnchors,
        editObj: (dst, src, value: string) => {
            if(value === "") {
                dst.frameAnchorProduct  = undefined
            }
        },
        editable: {
            type: "custom",
            copy: data => {
                return JSON.stringify([data.frameAnchorProduct, data.frameAnchorQtyOverride]);
            },
            paste: (data, value) => {
                if(value === "") {
                    data.frameAnchorProduct = undefined;
                    data.frameAnchorQtyOverride = null;
                    return;
                }

                const arr = JSON.parse(value);
                data.frameAnchorProduct = arr[0]
                data.frameAnchorQtyOverride = arr[1]
            },
            render: (props) =>
                <ProductCol
                   kind="frame-anchor"
                   width={props.width}
                   anchor={props.anchor}
                   onDone={(v: {product: number}[]) => props.onDone(Object.assign({}, props.row, {
                      frameAnchorProduct: v[0].product,
                   }))}
                   onCancel={props.onCancel}
                   initialValue={props.row.frameAnchorProductName || ""}
                />,
        },
        isChangedSinceBackup: (data: any) => {
            if(!data.backup) return false
            const backup = data.backup;

            return data.frameAnchorProduct !== backup.frameAnchorProduct || data.frameAnchorQtyOverride !== backup.frameAnchorQtyOverride;
        },
        filter: (data, search) => {
            return (data.frameAnchorProductName || "").toLowerCase().startsWith(search.toLowerCase())
        },
        sort: (a, b) => {
            return sortStringInner(a.frameAnchorProductName || "", b.frameAnchorProductName || "")
        }
    }
}

export const locationTransitions = ["To", "From", "To/From"];
export const openingTypes = ["Single", "Pair", "Window"]

export const hmMaterials = [
    {display: "A-60: Standard Galvanized Finish", value: "A-60"},
    {display: "G-90: Galvanized Finish", value: "G-90"},
]

export function lookupHollowMetalMaterial(value: string) {
    return first(hmMaterials, l => l.value === value);
}

export function frameMaterial<T extends {frameSeries: string}>(input: SelectInput<T>) {
    const data = input.props("frameSeries");

    if(data.frameSeries === aluminumFrame || data.frameSeries === existingFrame) {
        return []
    } else if(data.frameSeries === hollowMetalFrame) {
        return [
            lookupHollowMetalMaterial("A-60"),
            lookupHollowMetalMaterial("G-90"),
        ]
    } else if(data.frameSeries === "WD Frame") {
        return []
    }

    return [];
}

export const hmFrameGauges = [
    {display: "14", value: "14"},
    {display: "16", value: "16"},
    {display: "18", value: "18"},
    {display: "20", value: "20"},
]

export function frameGauge<T extends {frameSeries: string}>(input: SelectInput<T>) {
    const data = input.props("frameSeries")

    if(data.frameSeries === hollowMetalFrame) {
        return hmFrameGauges
    }

    return [];
}

export const allFrameConstructions = [
    {value: weldFrameConstruction, display: "WELD: Welded"},
    {value: kdFrameConstruction, display: "KD: Knockdown"},
]

export function frameConstructionLookup(value: string) {
    return first(allFrameConstructions, v => v.value === value);
}

export function frameConstruction<T extends {frameSeries: string}>(input: SelectInput<T>) {
    return [
        frameConstructionLookup("WELD"),
        frameConstructionLookup("KD"),
    ];
}

export const hmDoorGauges = [
    {display: "14", value: "14"},
    {display: "16", value: "16"},
    {display: "18", value: "18"},
    {display: "20", value: "20"},
];

export function doorGauge<T extends {doorSeries: string}>(input: SelectInput<T>) {
    const data = input.props("doorSeries")

    if(data.doorSeries === hollowMetalDoor) {
        return hmDoorGauges;
    }

    return [];
}

export const allHandings = [
    {value: "LHA", display: "LHA: Left Hand Active"},
    {value: "RHA", display: "RHA: Right Hand Active"},
    {value: "LHA/RHA", display: "LHA/RHA: Both Hands Active"},
    {value: "LHRA", display: "LHRA: Left Hand Reverse Active"},
    {value: "RHRA", display: "RHRA: Right Hand Reverse Active"},
    {value: "LHRA/RHRA", display: "LHRA/RHRA: Both Hands Reverse Active"},
    {value: "LHA-DA", display: "LHA-DA: Left Hand Active, Double Acting"},
    {value: "RHA-DA", display: "RHA-DA: Right Hand Active, Double Acting"},
    {value: "LHA/RHA-DA", display: "LHA/RHA-DA: Both Hands Active, Double Acting"},
    {value: "L-LHR", display: "L-LHR: Right Hand, Double Egress"},
    {value: "R-RHR", display: "R-RHR: Left Hand, Double Egress"},
    {value: "POCKET", display: "Pocket"},
    {value: "BYPASS", display: "Bypass"},
    {value: "BIFOLD", display: "Bifold"},
    {value: "LH", display: "LH: Left Hand"},
    {value: "RH", display: "RH: Right Hand"},
    {value: "LHR", display: "LHR: Left Hand Reverse"},
    {value: "RHR", display: "RHR: Right Hand Reverse"},
    {value: "LHR/LHR", display: "LHR/LHR: Right Hand, Double Egress"},
    {value: "RHR/RHR", display: "RHR/RHR: Left Hand, Double Egress"},
    {value: "LH-DA", display: "LH-DA: Left Hand, Double Acting"},
    {value: "RH-DA", display: "RH-DA: Right Hand, Double Acting"},
    {value: "CO", display: "CO: Cased Open"},
    {value: "LH-POCKET", display: "LH-POCKET: Left Hand , Pocket"},
    {value: "RH-POCKET", display: "RH-POCKET: Right Hand, Pocket"},
    {value: "LH-SLIDE", display: "LH-SLIDE: Left Hand, Sliding"},
    {value: "RH-SLIDE", display: "RH-SLIDE: Right Hand, Sliding"},
    {value: "LH-BIFOLD", display: "LH-BIFOLD: Left Hand, Bifold"},
    {value: "RH-BIFOLD", display: "RH-BIFOLD: Right hand, Bifold"},
    {value: "LHLH-COMM", display: "LH/LH-COMM: LH/LH, Communicating"},
    {value: "RHRH-COMM", display: "RH/RH-COMM: RH/RH, Communicating"},
    {value: "LHRH-COMM", display: "LH/RH-COMM: LH/RH, Communicating"},
    {value: "DBL POCKET", display: "DBL POCKET: Pocket Pair"},
    {value: "DBL BYPASS", display: "DBL BYPASS: Bypass Pair"},
    {value: "DBL BIFOLD", display: "DBL BIFOLD: Bifold Pair"},
    {value: "LH-BARN", display: "LH-BARN: Left Hand, Barn"},
    {value: "RH-BARN", display: "RH-BARN: Right Hand, Barn"},
]

export function handingLookup(value: string) {
    const val = first(allHandings, v => v.value === value);
    if(!val) throw new Error("missing value for '" + value + "'")
    return val;
}

// based on tyler's definitions in https://docs.google.com/spreadsheets/d/18J39MwGivW7NKoSZIw7Jkx1Fm0D7kDZ5NCvca3gMeg4/edit
// see also: core/opening/product.go
const pairMapping: {[k: string]: string[]} = {
    "DBL BIFOLD": ["LH", "RH"],
    "L-LHR": ["LHR", "LHR"],
    "LHA": ["LH", "RH"],
    "LHA-DA": ["LH", "LH"],
    "LHA/RHA": ["LH", "RH"],
    "LHA/RHA-DA": ["LH", "RH"],
    "LHRA": ["LHR", "RHR"],
    "LHRA/RHRA": ["LHR", "RHR"],
    "R-RHR": ["RHR", "RHR"],
    "RHA": ["RH", "LH"],
    "RHA-DA": ["RH", "RH"],
    "RHRA": ["RHR", "LHR"]
};

// see also: core/opening/topening/main.go
const bothActive = [
    "LHA/RHA", "LHRA/RHRA", "LHA/RHA-DA"
]

export function decodeHanding(handing: string, flipDoubleActive: boolean) {
    const pairObj = pairMapping[handing]
    if(!pairObj) {
        return {
            active: handing,
            inActive: null,
            doubleActive: false,
        }
    }

    const doubleActive = bothActive.includes(handing);
    let active = pairObj[0];
    let inActive = pairObj[1];

    if(doubleActive && flipDoubleActive) {
        active = pairObj[1];
        inActive = pairObj[0];
    }

    return {
        active: active,
        inActive: inActive,
        doubleActive: doubleActive,
    }
}

export function handingOptions<T extends {openingType: string}>(data: SelectInput<T>) {

    if(data.props("openingType").openingType === "Pair") {
        return [
            handingLookup("LHA"),
            handingLookup("RHA"),
            handingLookup("LHA/RHA"),
            handingLookup("LHRA"),
            handingLookup("RHRA"),
            handingLookup("LHRA/RHRA"),
            handingLookup("LHA-DA"),
            handingLookup("RHA-DA"),
            handingLookup("LHA/RHA-DA"),
            handingLookup("LHR/LHR"),
            handingLookup("RHR/RHR"),
            handingLookup("DBL POCKET"),
            handingLookup("DBL BYPASS"),
            handingLookup("DBL BIFOLD"),
        ]
    }

    return [
        handingLookup("LH"),
        handingLookup("RH"),
        handingLookup("LHR"),
        handingLookup("RHR"),
        handingLookup("LH-DA"),
        handingLookup("RH-DA"),
        handingLookup("CO"),
        handingLookup("LH-POCKET"),
        handingLookup("RH-POCKET"),
        handingLookup("LH-BARN"),
        handingLookup("RH-BARN"),
        handingLookup("LH-BIFOLD"),
        handingLookup("RH-BIFOLD"),
        handingLookup("LHLH-COMM"),
        handingLookup("RHRH-COMM"),
        handingLookup("LHRH-COMM"),
    ];
}

export function doorThicknesses(sys: UnitSystem | undefined){
    switch(sys) {
        case "metric":
            return ['35mm', '45mm', '57mm']
        default:
            return ['1 3/8"', '1 3/4"', '2 1/4"']
    }
}

// door thickness allows free-solo (custom) entry, but the value is later parsed
// to a number in backend calculations (dimension-formula engine, weld-frame
// component matching, imperial<->metric conversion), which panic on unparseable
// input. Reject anything the backend can't parse, expecting the project's unit system.
export function validateDoorThickness(sys: UnitSystem | undefined, str: string) {
    if(str.trim() === "") return;

    try {
        if(sys === "metric") {
            MetricDistance.parse(str);
        } else {
            ImperialDistance.parse(str);
        }
    } catch (e) {
        throw new Error(`"${str}" isn't a valid door thickness. Enter a dimension like ${sys === "metric" ? "45mm" : `1 3/4"`}.`);
    }
}

// normalize a free-solo thickness to the same canonical string the predefined
// options use (e.g. `1.75` -> `1 3/4"`, `45 mm` -> `45mm`) so typed and picked
// values stay byte-identical -- door_thickness is compared by string equality in
// hardware-group and pricing matching. Unparseable input is returned untouched so
// validateDoorThickness rejects it before save.
export function cleanDoorThickness(sys: UnitSystem | undefined, str: string): string {
    const value = str.trim();
    if(value === "") return "";

    try {
        if(sys === "metric") {
            // metric options are spaceless ("45mm"); MetricDistance.toString() adds a space
            return MetricDistance.parse(value).mm + "mm";
        }

        return ImperialDistance.parse(value).toInchesString();
    } catch (e) {
        return str;
    }
}

export const minJambDepth = 3 * ImperialDistance.unitsPerInch;
export const maxJambDepth = 20 * ImperialDistance.unitsPerInch;
// , 0.125
export function JambDepthCol<T extends TID>(name: string, key: NestedKeyOf<T>, width=100) {

    // jamb depth is ALWAYS imperial (because that's the way it is)
    return {
        name: name,
        render: (o: T) => lookupNestedProp(o, key),
        editable: {
            type: "string",
            parseValue: imperialInchParser,
            validate: (input: string) => {
                if (input === "") return;

                const val = ImperialDistance.parse(input);
                if (val.universalValue() < minJambDepth) throw new Error(`Jamb depth can't be less than ${ImperialDistance.fromUniversal(minJambDepth).toInchesString()}`);
                if (val.universalValue() > maxJambDepth) throw new Error(`Jamb depth can't be greater than ${ImperialDistance.fromUniversal(maxJambDepth).toInchesString()}`);
                if (val.sixtyFourthsOfInch % 2 !== 0) {
                    throw new Error(`Jamb depth must be a multiple of 1/8"`);
                }
            }
        },
        editKey: key,
        width: width,
        filter: keyMatch(key),
        sort: sortString(key),
    } as Column<T>;
}